/**
 * @file paddlejs demo
 * @author wanzhongyun
 */

import React from 'react';
import { Spin } from 'antd';
import { useLatest, useMount } from 'react-use';

import useJSExample from './PaddleExampleHooks';
import { IDemoProps } from './../../type';

import './style.less';

const PaddleExample: React.FC<IDemoProps> = React.memo(props => {
    const { image, setModelStatus } = props;
    const currentImage = useLatest(image);

    const {
        videoRef,
        demoRef,
        loadingStatus,
        closeFunc,
        setLoadingStatus,
        videoDomStatusFunc
    } = useJSExample(setModelStatus, currentImage);

    useMount(() => {
        setLoadingStatus(true);
        videoDomStatusFunc();
        const closeDom = document.querySelector('.paddle-js-online-exp-control-btn');
        closeDom?.addEventListener('mousedown', closeFunc, false);
        return () => {
            closeDom?.removeEventListener('mousedown', closeFunc);
        }
    });

    return <div className='paddle-js-demo'>
        <video className='demo-video' ref={videoRef}></video>
        {
            loadingStatus && <div className='demo-loading-mask' />
        }

        <Spin spinning={loadingStatus} size='large' tip='模型加载中...'>
            <canvas className='demo-canvas' ref={demoRef} />
        </Spin>
    </div>
});

export default PaddleExample;